import e from "../core/Tooltip.js";
import { TOOLTIP_OPEN_MODEL_VALUE_KEY as t } from "../injectionKeys.js";
import { createBlock as n, defineComponent as r, inject as i, isRef as a, openBlock as o, renderSlot as s, unref as c, withCtx as l } from "vue";
//#region src/components/ui/tooltip/wrapper/TooltipBind.vue?vue&type=script&setup=true&lang.ts
var u = /* @__PURE__ */ r({
	__name: "TooltipBind",
	props: {
		handleTooltipOpenUpdate: { type: Function },
		usedInDirectives: { type: Boolean },
		open: { type: Boolean },
		defaultOpen: { type: Boolean }
	},
	setup(r) {
		let u = r, d = i(t);
		return (t, r) => u.usedInDirectives ? (o(), n(e, {
			key: 0,
			open: u.open,
			"default-open": u.defaultOpen,
			"onUpdate:open": u.handleTooltipOpenUpdate
		}, {
			default: l(() => [s(t.$slots, "default")]),
			_: 3
		}, 8, [
			"open",
			"default-open",
			"onUpdate:open"
		])) : (o(), n(e, {
			key: 1,
			open: c(d),
			"onUpdate:open": r[0] ||= (e) => a(d) ? d.value = e : null
		}, {
			default: l(() => [s(t.$slots, "default")]),
			_: 3
		}, 8, ["open"]));
	}
});
//#endregion
export { u as default };

//# sourceMappingURL=TooltipBind_vue.js.map